import { useState } from "react";
import { Copy, Check } from "lucide-react";

export function CopyButton({ value, label = "Copy", testid }) {
  const [copied, setCopied] = useState(false);
  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(typeof value === "string" ? value : JSON.stringify(value, null, 2));
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      console.error("Copy failed:", e);
    }
  };
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={onClick}
      className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#1D4E89] hover:text-[#0A2342] transition px-2 py-1 rounded-md hover:bg-[#F1F5F9]"
    >
      {copied ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
      {copied ? "Copied" : label}
    </button>
  );
}

export function SectionLabel({ children }) {
  return <div className="dms-label">{children}</div>;
}

export function OutputBlock({ label, children, copyValue, testid }) {
  return (
    <div className="dms-card p-5" data-testid={testid}>
      <div className="flex items-center justify-between mb-3">
        <SectionLabel>{label}</SectionLabel>
        {copyValue !== undefined && <CopyButton value={copyValue} testid={testid ? `${testid}-copy` : undefined} />}
      </div>
      <div className="text-[15px] leading-relaxed text-[#1F2937]">{children}</div>
    </div>
  );
}
